import { makeKeysRoutes, RoutesViews } from '@gss/router';

export const makeKeysStepsBinds: RoutesViews<typeof makeKeysRoutes> = {};
